"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M396.3 312.5c0-113.3-145.8-145.8-145.8-270.8-82.1 51.2-33.2 157.1-33.2 193.6s-55.8 37.6-55.8-.2c0-27 3.9-43.5 7.9-57.4-44.9 36.5-64.7 93.5-64.7 134.8 0 80.5 65.3 145.8 145.8 145.8S396.3 393 396.3 312.5z"
  });
};

exports.default = _default;